import type { HTMLProps, MouseEvent, MouseEventHandler, ReactNode } from 'react';
import { forwardRef } from 'react';

import { DropdownThemeColor } from '@tmh-website/ui/Dropdown';

import * as Styled from './DropdownMenuItem.styles';

interface DropdownMenuItemProps extends Omit<HTMLProps<HTMLButtonElement>, 'type' | 'ref' | 'as' | 'forwardedAs'> {
  children: ReactNode;
  onSelect?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isActive?: boolean;
  themeColor: DropdownThemeColor;
}

const DropdownMenuItem = forwardRef<HTMLButtonElement, DropdownMenuItemProps>(
  ({ children, disabled, onSelect, isActive, themeColor, ...props }, ref) => {
    return (
      <Styled.Container
        as={props.href ? 'a' : 'button'}
        {...props}
        ref={ref}
        role='menuitem'
        disabled={disabled}
        $isActive={!!isActive}
        $themeColor={themeColor}
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          onSelect && onSelect(e);
          (props as any).onClick && (props as any).onClick(e);
        }}>
        {children}
      </Styled.Container>
    );
  }
);

export default DropdownMenuItem;
